import React__default from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { LoaderScreen, Alert } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusLoading, statusFailed, useIntl } from '@grandvisionhq/state';
import { isBookAppointmentEntrySelection } from '../../../state/types.js';
import { useRxUploadStatus } from '../hooks/us-rx-upload-status.js';
import { PrescriptionEntrySelectionStep } from './PrescriptionEntrySelectionStep.js';
import { getRxEntryTypes, getSelectedFrame, getPrescriptionType } from '../../../state/configurator/selectors.js';
import { updatePrescriptionType } from '../../../state/configurations/actions.js';
import { RX_SCOPE, PD_SCOPE } from '../../../state/constants.js';

const PrescriptionEntrySelectionStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    let rxEntryTypes = useSelector(getRxEntryTypes);
    const frame = useSelector(getSelectedFrame);
    const prescriptionType = useSelector(getPrescriptionType);
    const hasUpload = !!(rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.some(({ key  })=>key === 'PrescriptionFile'
    ));
    const uploadStatus = useRxUploadStatus([
        RX_SCOPE,
        PD_SCOPE
    ], hasUpload);
    const onChange = React__default.useCallback((value)=>{
        if (!frame) {
            return;
        }
        if (CommerceToolsApi.isPrescriptionType(value) || isBookAppointmentEntrySelection(value)) {
            dispatch(updatePrescriptionType({
                frameSku: frame.sku,
                prescriptionType: value,
                reason: 'user selection'
            }));
        }
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!frame || !rxEntryTypes || (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.length) === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed, null);
    }
    if (statusLoading(uploadStatus)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    if (statusFailed(uploadStatus)) {
        // remove upload from rxEntries
        rxEntryTypes = rxEntryTypes.filter(({ key  })=>key !== 'PrescriptionFile'
        );
    }
    return /*#__PURE__*/ React__default.createElement(PrescriptionEntrySelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: rxEntryTypes,
        selectedEntryItem: prescriptionType ? prescriptionType : rxEntryTypes[0].key
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "prescription-step__error"
    });
}

export { PrescriptionEntrySelectionStepContainer };
//# sourceMappingURL=PrescriptionEntrySelectionStepContainer.js.map
